import React, { useEffect } from "react";
import ReCAPTCHA from "react-google-recaptcha";

export default function Captcha({captchaRef}){

    return(
        <div className="hq-captcha"><ReCAPTCHA sitekey={`${process.env.GATSBY_GOOGLE_KEY}`} ref={captchaRef} /></div>
    )
}